import React, { useContext, useRef } from "react";
import Navbar from "../components/Navbar";
import img2 from "../assets/ignite-flyer.jpg";
import FormContext from "../FormContext";
import { useParams } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import { BsFillClockFill, BsPinMap, BsArrowBarLeft } from "react-icons/bs";
import Footer from "../components/Footer";
import moment from "moment";
import { Link } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { data } from "../data";
import { IoMdPricetags } from "react-icons/io";

const SingleSession = () => {
  const { sessions } = useContext(FormContext);

  const { id } = useParams();
  const sessionData = sessions.find(
    (session) => String(session?.sessionId) === String(id)
  );



  const handleBack = () => {
    window.history.back();
  };

  const sessionRef = useRef(null);
  const speakersRef = useRef(null);

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from(sessionRef.current, {
      x: -100,
      opacity: 0,
      duration: 1,
      ease: "in-out",
      scrollTrigger: {
        trigger: sessionRef.current,
        start: "top 80%",
        end: "top 50%",
        toggleActions: "play none none reverse",
      },
    });

    gsap.from(speakersRef.current, {
      x: -100,
      opacity: 0,
      duration: 1,
      ease: "in-out",
      scrollTrigger: {
        trigger: speakersRef.current,
        start: "top 80%",
        end: "top 50%",
        toggleActions: "play none none reverse",
      },
    });
  }, []);
  return (
    <div className="w-full min-h-screen bg-gray-100">
      <Navbar />

      {/*  a button to go back to the sessions page */}
      <div className="w-11/12 mx-auto mt-8">
        <button
          className="text-primary-color font-nueu text-xl rounded-md flex items-center gap-2"
          onClick={handleBack}
        >
          <BsArrowBarLeft className="text-primary-color" />
          Back to Sessions
        </button>
      </div>

      <div className="w-full md:w-4/5 mx-auto mt-6 mb-6 p-3 md:p-0">
        <div className="w-full relative h-full min-h-[400px] flex flex-col md:flex-row gap-2 bg-white rounded-lg overflow-clip">
          {/* Image section */}
          <div className="w-full md:w-1/2 min-h-[400px] max-h-[500px] h-full flex-shrink-0 overflow-hidden rounded-lg md:rounded-l-lg">
            <img
              src={id === "71" ? "https://smescaleup.org/banner-sme.png" : sessionData?.imageURL ?
                sessionData?.imageURL : img2}
              alt="session"
              className="w-full h-full object-cover"
            />
          </div>
          {/* Details section */}
          <div className="w-full md:w-1/2 flex flex-col gap-4 p-4 justify-between">
            <div>
              <h2 className="text-4xl font-semibold text-secondary-color font-nueu mb-2">
                {sessionData?.title}
              </h2>
              {/* Modern Payment Info Section - now directly under title */}
              {(sessionData?.sessionId === 64 || sessionData?.sessionId === 68) && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-2">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded flex items-center gap-1"><span role='img' aria-label='card'>💳</span> Full Payment</span>
                    {sessionData?.sessionId === 64 ? (
                      <>
                        <span className="text-gray-500 text-xl font-semibold line-through">₦1,000,000</span>
                        <span className="text-green-700 font-bold text-xl">₦900,000</span>
                        <span className="bg-green-200 text-green-800 text-xs font-bold px-2 py-1 rounded">10% OFF</span>
                      </>
                    ) : (
                      <>
                        <span className="text-gray-500 text-xl font-semibold line-through">₦500,000</span>
                        <span className="text-green-700 font-bold text-xl">₦450,000</span>
                        <span className="bg-green-200 text-green-800 text-xs font-bold px-2 py-1 rounded">10% OFF</span>
                      </>
                    )}
                  </div>
                  <div className="text-xs text-green-800 mt-1">Pay in full and save 10% instantly.</div>
                </div>
              )}
              {(sessionData?.sessionId === 62 || sessionData?.sessionId === 67) && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-2">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="bg-yellow-100 text-yellow-800 text-xs font-bold px-2 py-1 rounded flex items-center gap-1"><span role='img' aria-label='calendar'>🗓️</span> Installment Plan</span>
                    <span className="text-yellow-700 font-bold text-xl">{sessionData?.sessionId === 62 ? '₦100,000' : '₦50,000'}</span>
                    <span className="text-xs text-yellow-700 font-semibold">(Deposit)</span>
                  </div>
                  <div className="text-xs text-yellow-800 mb-2">Secure your spot with a deposit, then pay the rest in easy steps:</div>
                  <ol className="list-decimal ml-6 text-sm text-gray-700">
                    {sessionData?.sessionId === 62 ? (
                      <>
                        <li>First Deposit: ₦100,000</li>
                        <li>Mid August: ₦300,000</li>
                        <li>Mid September: ₦300,000</li>
                        <li>Mid October: ₦300,000</li>
                      </>
                    ) : (
                      <>
                        <li>First Deposit: ₦50,000</li>
                        <li>Mid August: ₦150,000</li>
                        <li>Mid September: ₦150,000</li>
                        <li>Mid October: ₦150,000</li>
                      </>
                    )}
                  </ol>
                  <div className="text-xs text-yellow-800 mt-2">You’ll receive reminders before each payment is due.</div>
                </div>
              )}
            </div>
            {/* Description and details */}
            <div>
              <p className="text-gray-600 text-sm mb-4 line-clamp-6" dangerouslySetInnerHTML={{ __html: sessionData?.description }}></p>
              <div className="flex flex-col gap-4">
                <div className="flex gap-2 items-center">
                  <FaCalendarAlt className="text-secondary-color" />
                  <p>{moment(sessionData?.date).format("MMMM Do YYYY")}</p>
                </div>
                <div className="flex gap-2 items-center">
                  <BsFillClockFill className="text-secondary-color" />
                  <p>{moment(sessionData?.date).startOf("day").add(8, "hours").format("h:mm a")}</p>
                </div>
                {sessionData?.isVirtual ? (
                  <div className="flex gap-2 items-center">
                    <BsPinMap className="text-secondary-color" />
                    <p>Virtual</p>
                  </div>
                ) : (
                  <div className="flex gap-2 items-center">
                    <BsPinMap className="text-secondary-color" />
                    <p>{sessionData?.location}</p>
                  </div>
                )}
              </div>
            </div>
            {/* Register button at the bottom */}
            <Link
              to={`/register/${sessionData?.sessionId}`}
              className="bg-primary-color text-white py-2 mt-4 font-nueu text-xl rounded-md text-center hover:bg-opacity-80 transition-all duration-300 ease-in-out"
            >
              Register
            </Link>
          </div>
        </div>
        {/* details */}
      </div>


      <div
        className="w-11/12 mx-auto my-12 flex flex-col justify-center items-center"
        ref={speakersRef}
      >
        <h2 className="text-4xl font-semibold my-8 text-primary-color font-nueu text-center">
          Meet the Speakers
        </h2>
        <div className="grid grid-rows-1 grid-cols-1 overflow-x-auto md:grid-cols-4 items-center gap-4 md:gap-2 w-11/12 justify-center mx-auto">
          {data.map((speaker, index) => (
            <div
              key={index}
              className=" flex flex-col items-center gap-2 text-center"
            >
              <img
                src={speaker.img}
                alt={speaker.name}
                className=" w-[200px] h-[200px] md:w-[200px] md:h-[200px] rounded-full object-contain object-bottom bg-gradient-to-br from-primary-color to-secondary-color"
              />
              <h1 className="text-2xl md:text-lg font-semibold text-secondary-color font-nueu">
                {speaker.name}
              </h1>
              <p className="text-sm  text-slate-700 w-4/5 md:w-11/12">{speaker.position}</p>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SingleSession;
